import React from 'react';
import LogoutComponent from '@/components/Logout';

export default function Logout() {
  return (
    <><LogoutComponent /></>
  );
}